export default __webpack_public_path__ + "static/media/p1.20105dd2.jpeg";